import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './components/auth/LoginPage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import PushTopicPage from './components/push-topic/PushTopicPage';
import AnalyticsPage from './components/analytics/AnalyticsPage';
import BotReviewPage from './components/review/BotReviewPage';
import AllBotsPage from './components/review/AllBotsPage';
import MarketingPage from './components/marketing/MarketingPage';
import SupportPage from './components/support/SupportPage';
import EnvironmentBanner from './components/layout/EnvironmentBanner';
import './App.css';

function App() {
  return (
    <>
      <EnvironmentBanner />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <PushTopicPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/analytics"
          element={
            <ProtectedRoute>
              <AnalyticsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/review"
          element={
            <ProtectedRoute>
              <BotReviewPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/all-bots"
          element={
            <ProtectedRoute>
              <AllBotsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/marketing"
          element={
            <ProtectedRoute>
              <MarketingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/support"
          element={
            <ProtectedRoute>
              <SupportPage />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default App;
